import EstimatesApi from "../services/api/estimates";
import CostbooksApi from "../services/api/costbooks-api";
import EstimateRowsApi from "../services/api/estimate-rows";
import { CustomersApi } from "../services/api/customers";
import { CompaniesApi } from "../services/api/companies";
import {TaxRatesApi} from "../services/api/tax-rates";
import {MarkupsApi} from "../services/api/markups";
import {PercentagesApi} from "../services/api/percentages";
import {AreaCostsModificationsApi} from "../services/api/area-costs-modifications";
import {Application} from "./application";
import OidcManager from "./api/oidcManager";
import {AppConfig} from "./app-config";
import {Reports} from "./api/reports";
import BookmarksApi from "./api/bookmarks";
import { QboApi } from "../services/api/qbo";
import { CustomersEstimatesApi } from "./api/customers-estimates";
import { InstancesApi } from "../services/api/instances";
import { AccountsApi } from "../services/api/accounts";

export class ApplicationApiManager {

    public estimate: EstimatesApi;
    public costbook: CostbooksApi;
    public estimateRows: EstimateRowsApi;
    public customersEstimates: CustomersEstimatesApi;
    public companies: CompaniesApi;
    public qbo: QboApi;
    public taxRates: TaxRatesApi;
    public markups: MarkupsApi;
    public percentages: PercentagesApi;
    public areaCostsModifications: AreaCostsModificationsApi;
    public reports: Reports;
    public bookmarks: BookmarksApi;
    public customers: CustomersApi;
    public instances: InstancesApi;
    public accounts: AccountsApi;

    constructor(private config: AppConfig, private oidc: OidcManager) {
        this.estimate = new EstimatesApi(oidc, this.config.api.estimator);
        this.customersEstimates = new CustomersEstimatesApi(oidc, this.config.api.estimator);
        this.companies = new CompaniesApi(oidc, this.config.api.estimator);
        this.qbo = new QboApi(oidc, this.config.api.estimator);
        this.estimateRows = new EstimateRowsApi(oidc, this.config.api.estimator);
        this.taxRates = new TaxRatesApi(oidc, this.config.api.estimator);
        this.markups = new MarkupsApi(oidc, this.config.api.estimator);
        this.percentages = new PercentagesApi(oidc, this.config.api.estimator);
        this.areaCostsModifications = new AreaCostsModificationsApi(oidc, this.config.api.estimator);
        this.reports = new Reports(oidc, this.config.api.estimator);
        this.bookmarks = new BookmarksApi(oidc, this.config.api.estimator);
        this.customers = new CustomersApi(oidc,this.config.api.estimator);
        this.costbook = new CostbooksApi(oidc, this.config.api.costbooks);
        this.instances = new InstancesApi(oidc, this.config.api.estimator);
        this.accounts = new AccountsApi(oidc, this.config.api.estimator);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/applicationApiManager.ts